import { useEffect, useState } from "react";
import { CaretRight } from "@phosphor-icons/react";

/** Sezione richiudibile dei form: i campi che non compili sempre stanno sotto "Altri dettagli". Si apre da sola se contiene già dati. */
export function AltriDettagli({ children, aperto = false, label = "Altri dettagli", riassunto = "", testId = "altri-dettagli" }) {
  const [open, setOpen] = useState(aperto);
  useEffect(() => { if (aperto) setOpen(true); }, [aperto]);
  return (
    <div className="border-t border-dashed border-slate-200 pt-2" data-testid={testId}>
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-2 py-1.5 text-xs font-semibold text-slate-600 hover:text-slate-900" data-testid={`${testId}-toggle`} aria-expanded={open}>
        <CaretRight size={12} weight="bold" className={`transition-transform ${open ? "rotate-90" : ""}`} />
        {label}
        {!open && riassunto && <span className="font-normal text-slate-400 truncate">· {riassunto}</span>}
      </button>
      {open && <div className="space-y-3 pt-1" data-testid={`${testId}-contenuto`}>{children}</div>}
    </div>
  );
}
